module.exports = __webpack_public_path__ + "static/media/ring.45e713ac.svg";